import { Accordion, Box } from "@chakra-ui/react";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import { Copyright } from "../Copyright";
import { isFooterCategory } from "../Footer.utils";
import { FooterLink } from "../FooterLink";
import type { FooterColumnContentItem, FooterLinksCategoryItem, FooterLinksCategoryType, FooterProps } from "../types";
import { FooterLinksCategory } from "./FooterLinksCategory";

const renderFooterCategory = ({
  _uid,
  footerLinksCategoryName,
  footerLinksCategoryItems,
  footerLinksCategoryDirection,
}: FooterLinksCategoryType) => (
  <FooterLinksCategory
    footerLinksCategoryDirection={footerLinksCategoryDirection}
    footerLinksCategoryName={footerLinksCategoryName}
    key={_uid}
  >
    {footerLinksCategoryItems.map(
      ({
        _uid,
        footerLinkItemName = "",
        footerLink,
        footerLinkIcon = "",
        footerLinkHideLinkForLanguages = undefined,
      }: FooterLinksCategoryItem) => (
        <FooterLink
          key={_uid}
          name={footerLinkItemName}
          icon={footerLinkIcon}
          footerLinkHideLinkForLanguages={footerLinkHideLinkForLanguages}
          footerLink={footerLink}
        />
      )
    )}
  </FooterLinksCategory>
);

const renderFooterColumnContent = (footerColumnContentItem: FooterColumnContentItem) =>
  isFooterCategory(footerColumnContentItem) ? (
    renderFooterCategory(footerColumnContentItem)
  ) : (
    <Box key={footerColumnContentItem._uid} px={8}>
      {renderDynamicComponent([footerColumnContentItem])}
    </Box>
  );

export const FooterMobile = ({ footerColumns, hideFlagBox }: FooterProps) => (
  <>
    <Accordion allowToggle pt={16} data-testid="mobile-footer-section">
      {footerColumns.map(({ footerColumnContent = [] }) => footerColumnContent.map(renderFooterColumnContent))}
    </Accordion>
    <Copyright hideFlagBox={hideFlagBox} />
  </>
);
